import Main from './components/Main'

function App() {
  return (
    <>
    <div className=' bg-pri-100'>
       <Main />
    </div>
   
    </>
  );
}

export default App;
